import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/category', label: '漫画分类' },
  { to: '/about', label: '关于我们' },
  { to: '/faq', label: '常见问题' },
];

export default function Navbar({ overHero = false }: { overHero?: boolean }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = !overHero || scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4">
        <Link to="/" className="group flex items-center gap-2" aria-label="韩漫星球首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide ${
              solid ? 'text-primary-700' : 'text-background-50'
            }`}
          >
            韩漫星球
          </span>
        </Link>

        <div className={`hidden md:flex items-center gap-1`}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : solid
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-white hover:bg-white/10'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 text-background-50 px-5 py-2 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line"></i> 开始阅读
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={open}
          className={`md:hidden flex h-10 w-10 items-center justify-center rounded-lg ${
            solid ? 'text-foreground-800 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
          }`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-lg text-sm font-medium ${
                    isActive ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/category"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-lg bg-accent-500 text-background-50 px-4 py-3 text-sm font-semibold whitespace-nowrap"
            >
              <i className="ri-search-line"></i> 开始阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}